import UserProfile from '../../components/UserProfile/UserProfile'
import CaseLayout from '../../layouts/CaseLayout/CaseLayout'

const Profile = () => {
  return (
    <CaseLayout floatingHeader={true} alwaysShowNav={false}>
      <UserProfile />
    </CaseLayout>
  )
}

export default Profile
